const prefix = 'APP_';

export const APP_COLLAPSE_SIDEBAR = `${prefix}COLLAPSE_SIDEBAR`;
